
import { createSlice } from '@reduxjs/toolkit';

export const upcomingMeeting_userSlice = createSlice({
    name: 'upcomingMeeting',
    initialState: {
        loading: false,
        data: [],
        error: false,
    },
    reducers: {
        UPCOMING_MEETING_FETCH_START: (state) => {
            state.loading = true;
        },
        UPCOMING_MEETING_FETCH_SUCCESS: (state, action) => {
            state.loading = false;
            state.data = action.payload;
        },
        UPCOMING_MEETING_FETCH_ERROR: (state) => {
            state.loading = false;
            state.error = true;
        },
        /**
         * Real-time update from Soketi (MeetingStatusChanged event).
         * Finds the card by room_name and patches is_start / expire_time in-place.
         * If the meeting ended (expire_time != null), removes it from the list.
         */
        MEETING_STATUS_UPDATED: (state, action) => {
            const { room_name, is_start, expire_time } = action.payload;
            const idx = state.data.findIndex(m => m.room_name === room_name);
            if (idx === -1) return;

            if (expire_time != null) {
                state.data.splice(idx, 1);
            } else {
                state.data[idx] = {
                    ...state.data[idx],
                    is_start,
                    expire_time,
                };
            }
        },
        /**
         * Real-time RSVP update from Soketi (MeetingRsvpUpdated event).
         * Patches the specific participant's rsvp_status on the host's meeting card.
         * payload: { room_name, invitee_name, status, status_label }
         */
        MEETING_RSVP_UPDATED: (state, action) => {
            const { room_name, invitee_name, status, status_label } = action.payload;
            const statusCodeMap = { accept: 1, maybe: 2, reject: 3 };
            const newCode = statusCodeMap[status];
            if (!newCode) return;

            const idx = state.data.findIndex(m => m.room_name === room_name);
            if (idx === -1) return;

            // Patch the participant entry inside the meeting's users array
            const meeting = state.data[idx];
            if (meeting.users) {
                const pIdx = meeting.users.findIndex(
                    p => p.name === invitee_name || p.user?.name === invitee_name
                );
                if (pIdx !== -1) {
                    meeting.users[pIdx] = {
                        ...meeting.users[pIdx],
                        rsvp_status: newCode,
                    };
                }
            }
        },
        /**
         * Real-time meeting invite from Soketi (MeetingInviteReceived event).
         * Signals the meeting list needs a refresh (we don't have full data here).
         * payload: { room_name, meeting_title, start_date, host_name, host_avatar }
         */
        MEETING_INVITE_RECEIVED: (state) => {
            // Mark as stale so the meeting list component refetches on next render.
            // We can't fully construct the card without a server round-trip.
            state.needsRefresh = true;
        },
    }
});

export const {
    UPCOMING_MEETING_FETCH_START,
    UPCOMING_MEETING_FETCH_SUCCESS,
    UPCOMING_MEETING_FETCH_ERROR,
    MEETING_STATUS_UPDATED,
    MEETING_RSVP_UPDATED,
    MEETING_INVITE_RECEIVED,
} = upcomingMeeting_userSlice.actions;

export default upcomingMeeting_userSlice.reducer;